// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file error/error_responses.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  InternalError,
  ResourceExhaustedError,
  UnavailableError,
  UnimplementedError,
} from './error_model_pb';
import { file_error_error_model } from './error_model_pb';

/**
 * Describes the file error/error_responses.proto.
 */
export const file_error_error_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChtlcnJvci9lcnJvcl9yZXNwb25zZXMucHJvdG8SFGNvbS5nZW0udmNzLmNvbnRyYWN0IrcCChNDb21tb25FcnJvclJlc3BvbnNlEk4KFnJlc291cmNlRXhoYXVzdGVkRXJyb3IYASABKAsyLC5jb20uZ2VtLnZjcy5jb250cmFjdC5SZXNvdXJjZUV4aGF1c3RlZEVycm9ySAASRgoSdW5pbXBsZW1lbnRlZEVycm9yGAIgASgLMiguY29tLmdlbS52Y3MuY29udHJhY3QuVW5pbXBsZW1lbnRlZEVycm9ySAASPAoNaW50ZXJuYWxFcnJvchgDIAEoCzIjLmNvbS5nZW0udmNzLmNvbnRyYWN0LkludGVybmFsRXJyb3JIABJCChB1bmF2YWlsYWJsZUVycm9yGAQgASgLMiYuY29tLmdlbS52Y3MuY29udHJhY3QuVW5hdmFpbGFibGVFcnJvckgAQgYKBHR5cGVCGAoUY29tLmdlbS52Y3MuY29udHJhY3RQAWIGcHJvdG8z',
    [file_error_error_model]
  );

/**
 * @generated from message com.gem.vcs.contract.CommonErrorResponse
 */
export type CommonErrorResponse = Message<'com.gem.vcs.contract.CommonErrorResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.CommonErrorResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.ResourceExhaustedError resourceExhaustedError = 1;
         */
        value: ResourceExhaustedError;
        case: 'resourceExhaustedError';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.UnimplementedError unimplementedError = 2;
         */
        value: UnimplementedError;
        case: 'unimplementedError';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.InternalError internalError = 3;
         */
        value: InternalError;
        case: 'internalError';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.UnavailableError unavailableError = 4;
         */
        value: UnavailableError;
        case: 'unavailableError';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CommonErrorResponse.
 * Use `create(CommonErrorResponseSchema)` to create a new message.
 */
export const CommonErrorResponseSchema: GenMessage<CommonErrorResponse> =
  /*@__PURE__*/
  messageDesc(file_error_error_responses, 0);
